import React from 'react';
import { useResponsive } from '../../hooks/useResponsive';
import { TransactionsPage } from './TransactionsPage';
import { TransactionsPageMobile } from './TransactionsPageMobile';

const TransactionsPageWrapper: React.FC = () => {
  const { isMobile } = useResponsive();

  return isMobile ? <TransactionsPageMobile /> : <TransactionsPage />;
};

export default TransactionsPageWrapper; 